module.exports = __webpack_public_path__ + "img/2026暑假咖啡屋通知.eeeaf5f8.png";